import { Component } from '@angular/core';
import { BlogService } from '../blog.service';
import { BlogPost } from '../blog-post';

@Component({
  selector: 'app-blog-posts',
  templateUrl: './blog-posts.component.html',
  styleUrls: ['./blog-posts.component.css']
})
export class BlogPostsComponent {
  constructor(public blogService: BlogService) { }

  allBlogPosts = this.blogService.allBlogPosts$

  addBlogPost() {
    this.blogService.keepFocus = true
    this.blogService.selectedBlogPost = undefined
    this.blogService.addingNewBlogPost = true
  }

  selectBlogPost(blogPost: BlogPost) {
    this.blogService.addingNewBlogPost = false
    this.blogService.selectedBlogPost = blogPost
  }
}
